import script from "./MapTemp.vue?vue&type=script&setup=true&lang=js"
export * from "./MapTemp.vue?vue&type=script&setup=true&lang=js"

import "./MapTemp.vue?vue&type=style&index=0&id=2ba9c7e0&lang=css"

const __exports__ = script;

export default __exports__